"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var comment_1 = __importDefault(require("./sub/comment"));
var link_1 = __importDefault(require("./sub/link"));
var main_media_1 = __importDefault(require("./sub/main-media"));
var logo_1 = __importDefault(require("./sub/logo"));
var title_1 = __importDefault(require("./sub/title"));
var transparencyButton_1 = __importDefault(require("./sub/transparencyButton"));
var description_1 = __importDefault(require("./sub/description"));
var badge_1 = __importDefault(require("./sub/badge"));
var size_1 = __importDefault(require("../hooks/size"));
function Content(props) {
    var adObj = props.adObj, native = props.adObj.native, _a = props.list, list = _a === void 0 ? false : _a;
    var _b = size_1.default(), ref = _b[0], size = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(comment_1.default, { placement: "Content", adObj: adObj }),
        React.createElement(link_1.default, { adObj: adObj, className: "u-mv8", style: {
                width: '100%',
                display: 'flex',
                flexDirection: list ? 'row' : 'column',
                textAlign: 'left',
                color: '#474445',
                backgroundColor: '#F6F8FB',
                textDecoration: 'none',
                borderRadius: '8px',
            }, ref: ref },
            React.createElement("div", { style: {
                    flex: '1 1 30%',
                    display: 'flex',
                    padding: list ? '8px 2px 8px 8px' : '0',
                } },
                React.createElement(main_media_1.default, { native: native, style: {
                        borderRadius: list ? '8px' : '8px 8px 0 0',
                        objectFit: 'cover',
                        width: '100%',
                        height: '100%',
                    } })),
            React.createElement("div", { style: {
                    flex: '1 1 70%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: size === 'large' ? '16px' : '8px 16px 16px 16px',
                } },
                React.createElement("div", { className: "u-d1", style: {
                        display: 'flex',
                        marginBottom: list ? '16px' : '8px',
                        color: '#767676',
                    } },
                    React.createElement(badge_1.default, { native: native }),
                    React.createElement(transparencyButton_1.default, { adObj: adObj, style: {
                            width: '18px',
                            height: '18px',
                            position: 'relative',
                            marginLeft: 'auto',
                            zIndex: 1,
                            opacity: 0.6,
                        } })),
                size === 'small' && (React.createElement(title_1.default, { native: native, className: "u-b1" })),
                React.createElement("div", { style: {
                        flex: '1 0 auto',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    } },
                    React.createElement("div", { style: {
                            flex: '0 1 auto',
                        } },
                        size !== 'small' && (React.createElement(title_1.default, { native: native, className: size === 'large' ? 'u-t3' : 'u-b1' })),
                        React.createElement(description_1.default, { native: native, className: size === 'large' ? 'u-caption' : 'u-d1' })),
                    React.createElement(logo_1.default, { native: native, style: {
                            height: 'auto',
                            flex: '0 1 auto',
                            maxHeight: '48px',
                            maxWidth: '20%',
                            alignSelf: 'flex-end',
                        } }))))));
}
exports.default = Content;
